import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import {
  AccountsFilter,
  AccountUpdateData,
  BankSettingsUpdateData,
  BookingNoteSettingsUpdateData,
  CustomerGroupUpdateData,
  CustomerSettingsUpdateData,
  DefaultGroupFilter,
  GetCustomerBookingsQuery,
  GroupsFilter,
  MaintainerBookingsFilter,
  OmaLiittymaUpdateData,
  OwnerBookingsFilter,
  RolesFilter,
  TarmoSettingsUpdateData,
  UpdateAddressData,
  VatSettingsUpdateData,
} from '../../features/Users/identityUsersSlice';
import axiosInstance from './axiosInstance';

const bffConfig = {
  headers: {
    ...apiRequestHeaders.csrfHeader(),
    ...apiRequestHeaders.activeSiteHeader(),
  },
};

export function fetchAllIdentityUsers() {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .get('/identity/identity/allusers', config)
    .then(res => {
      // console.error(res);
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}
export function fetchAllCustomerGroups(groupsFilter: GroupsFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: groupsFilter,
    contentType: 'application/json;charset=UTF-8',
  };
  return axios
    .get('/identity/identity/GetAllCustomerGroups', config)
    .then(res => {
      // console.error(res);
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchDefaultCustomerGroup(groupsFilter: DefaultGroupFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: groupsFilter,
    contentType: 'application/json;charset=UTF-8',
  };
  return axios
    .get('/identity/identity/getdefaultcustomergroup', config)
    .then(res => {
      // console.error(res);
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchAllAccountsFromDb(accountsFilter: AccountsFilter) {
  const config = {
    params: accountsFilter,
  };

  return axiosInstance
    .get('/identity/identity/getaccounts', config)
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchOwnerMaintainerAccounts(accountsFilter: AccountsFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: accountsFilter,
    contentType: 'application/json;charset=UTF-8',
  };
  return axios
    .get('/identity/identity/getownerandmaintaineraccounts', config)
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchOwnerAutoCompleteOptions(searchTerm: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { searchTerm },
  };

  return axios
    .get('/identity/identity/GetOwnerAutoCompleteOptions', config)
    .then(res => {
      return res;
    });
}

export function fetchAccommodationAccounts(accountsFilter: string[]) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: accountsFilter,
    paramsSerializer: function paramsSerializer(params) {
      // "Hide" the `answer` param
      return Object.entries({ ...params })
        .map(([key, value]) => `accountIds=${value}`)
        .join('&');
    },

    contentType: 'application/json;charset=UTF-8',
  };
  return axios
    .get('/identity/identity/getaccommodationaccounts', config)
    .then(res => {
      return res.data;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchCustomerBookings(query: GetCustomerBookingsQuery) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/booking/bookings/getallcustomerbookings', query, config)
    .then(res => {
      return res.data;
    });
}

export function fetchAllRoles(rolesFilter: RolesFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { rolesFilter },
  };

  return axios
    .get('/identity/identity/getallroles', config)
    .then(res => {
      // console.error(res);
      return res.data.result;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}
export function fetchIdentityUserRoles(identityId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { identityId },
  };

  return axios
    .get('/identity/identity/getuserroles', config)
    .then(res => {
      // console.error(res);
      return res.data.result;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}

export function fetchAccountRolesFromDb(accountId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accountId },
  };

  return axios
    .get('/identity/identity/getaccountrolesfromdb', config)
    .then(res => {
      // console.error(res);
      return res.data.result;
    })
    .catch(reason => {
      throw new Error(reason);
    });
}
export function fetchIdentityUserDetails(identityId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { identityId },
  };

  return axios.get('/identity/identity/finduser', config).then(res => {
    return res.data;
  });
}

export function fetchAllOwnerBookingsDetails(queryFilter: OwnerBookingsFilter) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/booking/bookings/getallownerbookings', queryFilter, config)
    .then(res => {
      return res.data;
    });
}

export function fetchAllMaintainerBookingsDetails(
  queryFilter: MaintainerBookingsFilter,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/booking/bookings/getallmaintainerbookings', queryFilter, config)
    .then(res => {
      return res.data;
    });
}

export function addaddressData(addressData: UpdateAddressData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/identity/identity/addaddress', addressData, config)
    .then(res => {
      return res.data;
    });
}

export function updateaddressData(addressData: UpdateAddressData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/identity/identity/updateaddress', addressData, config)
    .then(res => {
      return res.data;
    });
}

export function updateCustomerGroupData(
  customerGroupData: CustomerGroupUpdateData,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/identity/identity/updatecustomergroup', customerGroupData, config)
    .then(res => {
      return res.data;
    });
}
export function updateOmaLiittymaSettings(
  omaLiittymaSettings: OmaLiittymaUpdateData,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/identity/identity/updateomaliittymasettings',
      omaLiittymaSettings,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateBookingNoteSettings(
  bookingNoteSettings: BookingNoteSettingsUpdateData,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post(
      '/identity/identity/updatebookingnotesettings',
      bookingNoteSettings,
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function updateVatSettings(vatSettings: VatSettingsUpdateData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/identity/identity/updatevatsettings', vatSettings, config)
    .then(res => {
      return res.data;
    });
}
export function updateBankSettings(bankSettings: BankSettingsUpdateData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/identity/identity/updatebanksettings', bankSettings, config)
    .then(res => {
      return res.data;
    });
}

export function updateTarmoSettings(tarmoSettings: TarmoSettingsUpdateData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/identity/identity/updatetarmosettings', tarmoSettings, config)
    .then(res => {
      return res.data;
    });
}

export function updateCustomerSettings(
  customerSettings: CustomerSettingsUpdateData,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/identity/identity/updatecustomersettings', customerSettings, config)
    .then(res => {
      return res.data;
    });
}

export function updateAccountData(accountUpdateData: AccountUpdateData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/identity/identity/updateaccount', accountUpdateData, config)
    .then(res => {
      return res.data;
    });
}

export function markAccountDeleted(accountUpdateData: AccountUpdateData) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/identity/identity/deleteaccount', accountUpdateData, config)
    .then(res => {
      return res.data;
    });
}
export function fetchIdentityAddressDetails(addressId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { addressId },
  };
  return axios
    .get('/identity/identity/getaccommodationaddressbyaddressid', config)
    .then(res => {
      return res.data.result;
    });
}

export function fetchAccountDetailsFromDb(accountId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accountId },
  };

  return axios
    .get('/identity/identity/getaccountdetailsfromdb', config)
    .then(res => {
      return res.data.result;
    });
}

export function fetchOmaLiittymaSettings(accountId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accountId },
  };

  return axios
    .get('/identity/identity/getomaliittymasettingsbyaccountid', config)
    .then(res => {
      return res.data.result;
    });
}

export function fetchOfficerSettings(accountId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accountId },
  };

  return axios
    .get('/identity/identity/getofficersettingsbyaccountid', config)
    .then(res => {
      return res.data.result;
    });
}

export function fetchMyAgentNumber(): Promise<number | null> {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .get('/identity/identity/getmyagentnumber', config)
    .then(res => res.data.result as number | null);
}

export function updateOfficerSettings(data: {
  accountId: string;
  agentNumber: number | null;
}) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/identity/identity/updateofficersettings', data, config)
    .then(res => res.data);
}
export function fetchBankSettings(accountId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accountId },
  };

  return axios
    .get('/identity/identity/getbanksettingsbyaccountid', config)
    .then(res => {
      return res.data.result;
    });
}

export function fetchTarmoSettings(accountId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accountId },
  };

  return axios
    .get('/identity/identity/gettarmosettingsbyaccountid', config)
    .then(res => {
      return res.data.result;
    });
}

export function fetchCustomerSettings(accountId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accountId },
  };

  return axios
    .get('/identity/identity/getcustomersettingsbyaccountid', config)
    .then(res => {
      return res.data.result;
    });
}
export function fetchCustomerGroupDetails(customerGroupId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { customerGroupId },
  };

  return axios
    .get('/identity/identity/getCustomerGroupDetails', config)
    .then(res => {
      return res.data;
    });
}
export function fetchBookingNoteSettings(accountId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accountId },
  };

  return axios
    .get('/identity/identity/getbookingnotesettingsbyaccountid', config)
    .then(res => {
      return res.data.result;
    });
}

export function fetchVatSettings(accountId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accountId },
  };

  return axios
    .get('/identity/identity/getvatsettingsbyaccountid', config)
    .then(res => {
      return res.data.result;
    });
}
export function fetchPersonalIdentityData(accountId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accountId },
  };

  return axios
    .get('/identity/identity/getpersonalidentitydata', config)
    .then(res => {
      return res.data.result ?? res.data;
    });
}
export interface SavePersonalIdentityRequest {
  accountId: string;
  personalIdentityCode: string;
}
export function savePersonalIdentity(request: SavePersonalIdentityRequest) {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/identity/identity/savepersonalidentity', request, config)
    .then(res => res.data);
}

export function deletePersonalIdentity(accountId: string) {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/identity/identity/deletepersonalidentity', accountId, config)
    .then(res => res.data);
}

export interface CreateIdentityVerificationLinkRequest {
  accountId: string;
  returnUrl?: string;
}

export function createIdentityVerificationLink(
  request: CreateIdentityVerificationLinkRequest,
): Promise<string> {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/identity/identity/createidentityverificationlink', request, config)
    .then(res => res.data);
}

export function fetchUserDetailsByIdentityId(identityId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { identityId },
  };

  return axios
    .get('/user/users/getuserdetailsbyidentityid', config)
    .then(res => {
      return res.data.result;
    });
}
const getIdentityClaims = async () => {
  try {
    const res = await axios.get('/bff/user', bffConfig);
    return res.data;
  } catch (error) {
    throw new Error(error.toJSON());
  }
};

const getAuthorizationClaims = async () => {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  try {
    const res = await axios.get(
      '/identity/identity/GetAuthorizationClaims',
      config,
    );
    return res.data;
  } catch (error) {
    throw new Error(error.toJSON());
  }
};

const addUserPrivateLoginAsync = async (accountId: string) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  const res = await axios.post(
    '/identity/identity/AddPrivateUserLogin',
    accountId,
    config,
  );
  return res.data;
};

const deleteUserLoginAsync = async (accountId: string) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  const res = await axios.post(
    '/identity/identity/DeleteUserLogin',
    accountId,
    config,
  );
  return res.data;
};

const restoreUserAsync = async (accountId: string) => {
  const config = {
    headers: {
      'Content-Type': 'application/json',
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  const res = await axios.post(
    '/identity/identity/RestoreUser',
    accountId,
    config,
  );
  return res.data;
};

const getActiveSite = async () => {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  const res = await axios.get('/identity/identity/getActiveSite', config);
  return res.data;
};

const updateActiveSite = async (siteId: string) => {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  const res = await axios.post(
    '/identity/identity/updateActiveSite',
    { siteId },
    config,
  );
  return res.data;
};

const userService = {
  getIdentityClaims,
  getAuthorizationClaims,
  addUserPrivateLoginAsync,
  deleteUserLoginAsync,
  restoreUserAsync,
  getActiveSite,
  updateActiveSite,
};

export default userService;
